// Money — currency display with optional emphasized integer + small cents, and
// gain/loss tone. Wraps formatCurrency so every dollar value renders the same.
import PropTypes from 'prop-types';
import { cx } from '../../../utils/cx';
import { formatCurrency } from '../../../utils/format';
import './money.css';

export function Money({ value, cents = true, tone, size = 'md', splitCents = false, className }) {
  if (splitCents && cents) {
    const [intPart, centPart] = formatCurrency(value).replace('$', '').split('.');
    // Non-numeric values (null/undefined → "—") have no cents part; render the
    // placeholder plainly instead of "$—.undefined".
    if (centPart === undefined) {
      return (
        <span className={cx('money', `money--${size}`, tone && `money--${tone}`, className)}>
          {intPart}
        </span>
      );
    }
    return (
      <span className={cx('money', `money--${size}`, tone && `money--${tone}`, className)}>
        <span className="money__sym">$</span>
        {intPart}
        <span className="money__cents">.{centPart}</span>
      </span>
    );
  }
  return (
    <span className={cx('money', `money--${size}`, tone && `money--${tone}`, className)}>
      {formatCurrency(value, cents)}
    </span>
  );
}

Money.propTypes = {
  value: PropTypes.number,
  cents: PropTypes.bool,
  /** Color for positive/negative emphasis. */
  tone: PropTypes.oneOf(['gain', 'loss', 'muted']),
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'hero']),
  /** Render cents smaller than the integer part (for hero balances). */
  splitCents: PropTypes.bool,
  className: PropTypes.string,
};

export default Money;
